import AuthApi from "app/api/auth";
import { handleGenericApiError } from "app/api/error";
import { createAuthData, resetAuthData } from "app/services/auth";

import { addLoading, removeLoading } from "./loading";

export const ACTION_AUTH_AUTHENTICATE = "auth:ACTION_AUTH_AUTHENTICATE";
export const ACTION_AUTH_ME = "auth:ACTION_AUTH_ME";
export const ACTION_AUTH_RECOVERY = "auth:ACTION_AUTH_RECOVERY";
export const ACTION_AUTH_ADDRESS = "auth:ACTION_AUTH_ADDRESS";

export const saveAuthData = (payload, callback) => async () => {
  try {
    createAuthData(payload);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const refresh = (token, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await AuthApi.refresh(token);
    if (!data) {
      throw new Error("Sua sessão expirou");
    }
    dispatch({
      type: ACTION_AUTH_AUTHENTICATE,
      payload: data,
    });
    createAuthData(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    return data;
  } catch (err) {
    handleGenericApiError({
      response: {
        status: 401,
        message: "Sua sessão expirou",
      },
    });
  } finally {
    dispatch(removeLoading());
  }
};

export const authenticate = (userData, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await AuthApi.auth(userData);
    dispatch({
      type: ACTION_AUTH_AUTHENTICATE,
      payload: data,
    });
    createAuthData(data);

    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const authenticateToken = data => async dispatch => {
  dispatch(addLoading());
  try {
    dispatch({
      type: ACTION_AUTH_AUTHENTICATE,
      payload: data,
    });
    createAuthData(data);
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const getAuthenticateUrl = (recaptcha, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await AuthApi.getAuthUrl(recaptcha);
    if (callback && typeof callback === "function") {
      callback(data);
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const logout = callback => async dispatch => {
  dispatch(addLoading());
  try {
    dispatch({
      type: ACTION_AUTH_AUTHENTICATE,
      payload: null,
    });
    resetAuthData();
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const getMe = () => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await AuthApi.me();

    if (data)
      dispatch({
        type: ACTION_AUTH_ME,
        payload: data,
      });
    return data;
  } catch (err) {
    handleGenericApiError(err);
    throw err;
  } finally {
    dispatch(removeLoading());
  }
};

export const sendRecoveryToken = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await AuthApi.sendRecoveryToken(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const changePassword = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await AuthApi.changePassword(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
